import { MediaCategoryTypeEnum } from 'app/shared/enums/media-category-type.enum.model';
import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

import { MediaTypeEnum } from '../../../shared/enums/media-type.enum.model';
import { MediaDTO, OrderedMediaDTO } from '../../../shared/models/media.models';


export class MediagMapper {

  public static uploadMedia(files: File[], baseUrl: string): HttpBasicRequest[] {

    const result: HttpBasicRequest[] = [];
    files.forEach(file => {
      const formData = new FormData();
      formData.append('file', file);
      result.push({
        url: baseUrl + '/media/upload-media', method: 'post', body: formData, options: {
          params: {
            name: file.name,
            type: MediaTypeEnum.image,
            category: MediaCategoryTypeEnum.Draft
          }
        }
      });
    });
    return result;
  }

  public static updateAssociatedMedia(mediaUploaded: MediaDTO[], media: OrderedMediaDTO[], cacheMedia: OrderedMediaDTO[], baseUrl: string, nodeId: number, nodeUrl: 'products' | 'assortments' | 'variants'): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    media.filter((media1) =>
      !cacheMedia.some(media2 => UtilityFunctions.isMatch(media1, media2))).filter(item =>
        item.order === 1 || !item.media.id).forEach(item => {
          const body = {
            mediaId: item.media?.id ? item.media.id : mediaUploaded?.find(el => el.name === item.media?.name)?.id,
            order: item.order,
            validityDateFrom: item.validityDateFrom,
            validityDateTo: item.validityDateTo,
            visible: item.visible
          };
          result.push({ url: baseUrl + `/${nodeUrl}/${nodeId}/media`, method: item.media?.id ? 'put' : 'post', body });
        });
    return result;
  }

}
